module.exports = "https://static.wmbcdn.com/uniweb/images/760292e79ff941cc349fb2553acfd406.svg";